//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getview, addCreditParty, updateZj, checkZj, getstep } from '@/api/jfhl.js'
import { award, isAward } from '@/api/lottery'
import descStar from '@/assets/jfcj/desc_star.png'
import descBottom from '@/assets/jfcj/bottom_bg.png'
import AddressInfo from './address-info'
import HeaderDialog from './header-dialog'
export default {
  components: {
    AddressInfo,
    HeaderDialog
  },
  data () {
    return {
      desc_star: descStar,
      desc_bottom: descBottom,
      times: 0,
      showtouch: true, // 是否显示刮奖区
      msg: '',
      context: '',
      isaward: 2, // 是否抽奖，2，未抽奖，1,已抽奖
      iszhongjiang: '', // 是否中奖，2，未中奖，1,已中奖
      zhongjiang: false, // 是否抽中实物
      partyid: this.$route.params.partyid,
      lotid: 0,
      lottery: true,
      gkNum: '', // 关卡数
      passNum: '' // 闯关次数
    }
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    }
  },
  mounted () {
    this.view()
    this.init()
  },
  methods: {
    view () {
      getview({
        id: this.partyid
      }).then(res => {
        this.lotid = res.obj.lotid
        this.getstep()
      })
    },
    getstep () {
      getstep({
        accountid: this.accountid,
        partyid: this.partyid
      }).then(res => {
        this.times = 3 - res.obj.num
        var _this = this
        this.gkNum = res.obj.gknum
        this.passNum = res.obj.num
        this.getCheckZj()
      })
    },
    getCheckZj () {
      checkZj({
        partyid: this.partyid,
        accountid: this.accountid,
        lotid: this.lotid
      }).then(data => {
        var _this = this
        if (data.obj.num === 1 && data.obj.isaward === 1) {
          this.$vux.alert.show({
            content: '今天已经中奖了，请明天再来~',
            buttonText: '查看抽奖记录',
            onHide () {
              _this.back(2)
            }
          })
        } else {
          if (this.passNum === 0) {
            this.$vux.alert.show({
              content: '您还没有参与答题闯关',
              buttonText: '前去闯关',
              onHide () {
                _this.handup()
              }
            })
            return
          }
          if (this.passNum >= 3 && this.gkNum === 0) {
            this.$vux.alert.show({
              content: '今天闯关次数已达上限',
              buttonText: '回到首页',
              onHide () {
                _this.back(1)
              }
            })
            return
          }
          if (this.gkNum !== 5) {
            this.$vux.alert.show({
              content: '您还未闯关成功',
              buttonText: '前去闯关',
              onHide () {
                _this.handup()
              }
            })
          }
        }
      })
    },
    // 是否中奖
    isAward () {
      isAward({
        lotid: this.lotid,
        openid: this.accountid
      }).then(data => {
        this.iszhongjiang = data.obj.iszhongjiang
        if (data.obj.iszhongjiang === 1) {
          this.msg = '今天已经中了' + data.obj.item + '，请明天再来~'
          this.times = 0
          // 奖品是积分
          if (data.obj.item.indexOf('积分') !== -1) {
            this.addJiFen(data.obj.item.replace(/[^0-9]/ig, ''))
            this.zhongjiang = false
          } else {
            this.zhongjiang = true
          }
        } else if (data.obj.iszhongjiang === 2) {
          if (this.times === 2) {
            this.msg = '谢谢参与~'
          } else if (this.times === 1) {
            this.msg = '谢谢参与~'
          } else if (this.times === 0) {
            this.msg = '很遗憾没中奖，您今天闯关次数已达上限请明天再来~'
          }
        }
      })
    },
    getLottery () {
      this.lottery = false
      award({
        lotid: this.lotid,
        openid: this.accountid
      }).then(data => {
        this.showtouch = false
        data.obj.isaward = 1
        this.isaward = data.obj.isaward
        if (this.isaward === 1) {
          this.isAward()
        }
        updateZj({
          partyid: this.partyid,
          accountid: this.accountid
        }).then(data => {
          console.log(data)
        })
        this.getstep()
      })
    },
    // 积分添加
    addJiFen (credit) {
      addCreditParty({
        accoutid: this.accountid,
        credit: credit,
        partyid: this.partyid,
        type: 1
      }).then(res => {
        if (res.msg.indexOf('兑换成功') !== -1) {
          this.$vux.toast.text('积分添加成功！')
        } else {
          this.$vux.toast.text('积分添加失败！')
        }
      })
    },
    back (item) {
      this.$router.push({ name: 'integralDraw7', params: { partyid: this.partyid, type: item } })
    },
    handup () {
      this.$router.push({ name: 'integralDraw8', params: { partyid: this.partyid } })
    },
    address () {
      this.$refs.addressInfo.showDialog()
    },
    init () {
      let canvas = document.getElementById('mask')
      let context = canvas.getContext('2d')
      context.fillStyle = '#d1d1d1'
      context.fillRect(0, 0, 260, 120)
      context.font = '26px arial'
      context.fillStyle = '#666'
      context.textAlign = 'center'
      context.textBaseline = 'middle'
      context.fillText('刮奖区', 130, 60)
      context.globalCompositeOperation = 'destination-out'
      this.context = context
      // 鼠标按下 增加mousemove的事件监听
      canvas.addEventListener('touchstart', this.drawArcMouseHandle)
      canvas.addEventListener('touchsend', event => {
        // 鼠标抬起之后，把mousemove的事件监听撤销掉
        this.removeEventListener('touchmove', this.mousemoveHandle)
      })
      // 监听 touchmove
      canvas.addEventListener('touchmove', this.drawArcTouchHandle)
    },
    // 根据鼠标的move画圆
    drawArcMouseHandle (event) {
      event.preventDefault()
      event.target.addEventListener('touchmove', this.mousemoveHandle)
    },
    // 为了能够移除movesemove的事件需要单独处理一下
    mousemoveHandle (event) {
      console.log(event)
      event.preventDefault()
      this.drawArcByPoint(event.pageX, event.pageY)
    },
    // 根据触摸点画圆
    drawArcTouchHandle (event) {
      event.preventDefault()
      var touch = event.touches[0]
      this.drawArcByPoint(touch.pageX, touch.pageY - 245)
    },
    // 根据某个点在canvas上画圆
    // x 坐标和 y 坐标 两个坐标是触摸点的坐标而不是画圆的圆心
    // 圆心通过计算得出
    drawArcByPoint (x, y) {
      console.log(x)
      this.context.beginPath()
      this.context.stroke()
      this.context.arc(
        x - canvas.offsetLeft,
        y - canvas.offsetTop,
        15,
        0,
        Math.PI * 2
      )
      this.context.closePath()
      this.context.fillStyle = '#ffffff'
      this.context.fill()
      this.checkComplete()
    },
    // 判断是否完成刮奖 点数大于80%
    checkComplete () {
      var imgData = this.context.getImageData(0, 0, 260, 120)
      var pxData = imgData.data // 获取字节数据
      var len = pxData.length // 获取字节长度
      var count = 0 // 记录透明点的个数
      // 主要的思想是 一个像素由四个数据组成，每个数据分别是 rgba() 所以第四个数据 a 表示alpha透明度
      for (var i = 0; i < len; i += 4) {
        var alpha = pxData[i + 3] // 获取每个像素的透明度
        if (alpha < 10) {
          // 透明度小于10
          count++
        }
      }
      var percent = count / (len / 4) // 计算百分比
      // 如果百分比大于0.8 则表示成功
      if (percent > 0.5) {
        if (this.lottery) {
          this.getLottery()
        }
      }
    }
  }
}
